"use client";

import { useSyncExternalStore } from "react";

/**
 * The current URL's query string ("?redirect=…", or "") for the language
 * switchers, so changing language keeps the reader's place: the sign-in page
 * lost its `?redirect=` and dropped the reader on the dashboard instead
 * (2026-10-19 QA). Read as a store rather than `useSearchParams`, which would
 * force a Suspense boundary around the site chrome: "" on the server and
 * during hydration, the real value on the next client render, and re-read on
 * every render after (each navigation re-renders the chrome) and on popstate.
 */
function subscribe(onChange: () => void): () => void {
  window.addEventListener("popstate", onChange);
  return () => window.removeEventListener("popstate", onChange);
}

export function useLocationSearch(): string {
  return useSyncExternalStore(
    subscribe,
    () => window.location.search,
    () => "",
  );
}
